var map = {
	"./Gallery-1.png": 320,
	"./Gallery-10.jpeg": 321,
	"./Gallery-11.jpeg": 322,
	"./Gallery-12.jpeg": 323,
	"./Gallery-13.jpeg": 324,
	"./Gallery-14.jpeg": 325,
	"./Gallery-15.jpeg": 326,
	"./Gallery-16.jpeg": 327,
	"./Gallery-17.jpeg": 328,
	"./Gallery-18.jpeg": 329,
	"./Gallery-19.jpeg": 330,
	"./Gallery-2.JPG": 331,
	"./Gallery-20.jpeg": 332,
	"./Gallery-21.jpeg": 333,
	"./Gallery-22.jpeg": 334,
	"./Gallery-3.jpg": 335,
	"./Gallery-4.jpg": 336,
	"./Gallery-5.jpg": 337,
	"./Gallery-6.jpg": 338,
	"./Gallery-7.jpg": 339,
	"./Gallery-8.jpg": 340,
	"./Gallery-9.jpeg": 341,
	"./gallery-img.jpeg": 342,
	"./gallery-img10.jpeg": 343,
	"./gallery-img2.jpeg": 344,
	"./gallery-img3.jpeg": 345,
	"./gallery-img4.jpeg": 346,
	"./gallery-img5.jpeg": 347,
	"./gallery-img6.jpeg": 348,
	"./gallery-img7.jpeg": 349,
	"./gallery-img8.jpeg": 350,
	"./gallery-img9.jpeg": 351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;